import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
  base: {
    borderRadius: '3xl',
    colorPalette: 'neutral',
  },
  variants: {
    variant: {
      outline: {
        borderColor: 'colorPalette.solid',
      },
      plain: {
        color: 'colorPalette.solid',
      },
    },
  },
});
